var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-desc"},[_c('p',[_vm._v(_vm._s(_vm.label))]),_c('p',[(_vm.negrito)?_c('b',[_c('span',[_vm._v(_vm._s(_vm.descricao))])]):_vm._e(),_vm._v(" "),(!_vm.negrito)?_c('span',[_vm._v(_vm._s(_vm.descricao))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }